module.exports = "<div>\n  <brothers-attribution-page>\n  </brothers-attribution-page>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/events-screen/white-board/white-board.component.html
// module id = ./src/app/admin/events-screen/white-board/white-board.component.html
// module chunks = main